<template>
  <div class="visit-menu-configuration">
    <vx-card :title="pageTitle" class="visit-menu-page-card">
      <vx-card title="Configuration Setting" class="mb-6">
        <div class="filter-inline">
          <div class="filter-field">
            <label class="vs-input--label">Territory</label>
            <multiselect
              class="selectExample"
              v-model="selectedTerritory"
              :options="optionTerritory"
              :multiple="false"
              :allow-empty="true"
              :show-labels="false"
              :max-height="160"
              :disabled="filtersLocked"
              placeholder="Type to search"
              track-by="id"
              label="name"
              :internal-search="false"
              :searchable="true"
              @search-change="handlerSearchTerritory"
              :custom-label="customLableTerritory"
            />
          </div>
          <div class="filter-field">
            <label class="vs-input--label">Role User</label>
            <multiselect
              class="selectExample"
              v-model="selectedRole"
              :options="optionRole"
              :multiple="false"
              :allow-empty="true"
              :show-labels="false"
              :max-height="160"
              :disabled="filtersLocked"
              placeholder="Select role"
              track-by="id"
              :custom-label="customLabelRole"
            />
          </div>
          <div class="filter-field">
            <label class="vs-input--label">Salesman Subtype</label>
            <multiselect
              class="selectExample"
              v-model="selectedSubtype"
              :options="optionSubtype"
              :multiple="false"
              :allow-empty="false"
              :show-labels="false"
              :max-height="160"
              :disabled="filtersLocked"
              placeholder="Select salesman subtype"
              track-by="work_position_id"
              label="subtype_name"
              :internal-search="false"
              @search-change="handlerSearchSubtype"
            />
          </div>
          <div class="filter-actions" v-if="mode === 'create'">
            <vs-button
              color="primary"
              icon-pack="feather"
              icon="icon-search"
              @click="handleApply"
            >
              Apply
            </vs-button>
            <vs-button
              type="border"
              icon-pack="feather"
              icon="icon-rotate-ccw"
              @click="handleReset"
            >
              Reset
            </vs-button>
          </div>
        </div>
      </vx-card>

      <vx-card title="Configurable Item">
        <div class="config-item-table mb-base" v-if="items.length">
          <div class="vs-con-table">
            <div class="vs-con-tbody vs-table--content">
              <table class="vs-table vs-table--tbody-table visit-menu-table">
                <thead>
                  <tr>
                    <th rowspan="2" class="th-order">Order</th>
                    <th rowspan="2" class="th-num">#</th>
                    <th rowspan="2">Item Menu</th>
                    <th rowspan="2">Status</th>
                    <th colspan="1" class="th-group">Sequence</th>
                    <th colspan="3" class="th-group th-group-center">
                      Out of Radius
                    </th>
                  </tr>
                  <tr>
                    <th class="th-sub">Number</th>
                    <th class="th-sub">Control</th>
                    <th class="th-sub">In Route</th>
                    <th class="th-sub">Off Route</th>
                  </tr>
                </thead>
                <draggable
                  :list="items"
                  tag="tbody"
                  handle=".drag-handle"
                  :disabled="readOnly"
                  @end="recomputeSequence"
                >
                  <tr
                    v-for="(row, index) in items"
                    :key="row.id || row.menu_name || index"
                  >
                    <td class="td vs-table--td col-order">
                      <i
                        v-if="!readOnly"
                        class="feather icon-move drag-handle"
                        title="Move row"
                      />
                      <span v-else class="text-grey">-</span>
                    </td>
                    <td class="td vs-table--td">{{ index + 1 }}</td>
                    <td class="td vs-table--td">{{ row.menu_name }}</td>
                    <td class="td vs-table--td">
                      <div class="cell-content cell-content--status">
                        <vs-switch
                          width="120px"
                          color="success"
                          :disabled="readOnly"
                          :value="isRowActive(row)"
                          @input="(val) => handleStatusInput(row, val)"
                        >
                          <span slot="on">Active</span>
                          <span slot="off">Inactive</span>
                        </vs-switch>
                      </div>
                    </td>
                    <td class="td vs-table--td">
                      <div class="cell-content cell-content--sequence">
                        <span v-if="!isRowActive(row)">-</span>
                        <vs-input
                          v-else
                          type="number"
                          class="sequence-input"
                          :value="row.sequence_number"
                          :disabled="readOnly"
                          min="1"
                          :max="activeItemCount"
                          @input="(val) => handleSequenceInput(row, val)"
                          @blur="() => handleSequenceInput(row, row.sequence_number)"
                        />
                      </div>
                    </td>
                    <td class="td vs-table--td">
                      <div class="cell-content cell-content--control">
                        <control-select
                          v-if="isRowActive(row)"
                          v-model="row.sequence_control"
                          :options="controlOptions"
                          :disabled="readOnly"
                        />
                        <span v-else class="text-grey">-</span>
                      </div>
                    </td>
                    <td class="td vs-table--td">
                      <div class="cell-content cell-content--control">
                        <control-select
                          v-if="isRowActive(row)"
                          v-model="row.out_of_radius_in_route"
                          :options="controlOptions"
                          :disabled="readOnly"
                        />
                        <span v-else class="text-grey">-</span>
                      </div>
                    </td>
                    <td class="td vs-table--td">
                      <div class="cell-content cell-content--control">
                        <control-select
                          v-if="isRowActive(row)"
                          v-model="row.out_of_radius_off_route"
                          :options="controlOptions"
                          :disabled="readOnly"
                        />
                        <span v-else class="text-grey">-</span>
                      </div>
                    </td>
                  </tr>
                </draggable>
              </table>
            </div>
          </div>
          <p
            v-if="!readOnly"
            class="mt-3 text-sm flex items-center text-grey"
          >
            <feather-icon icon="InfoIcon" svgClasses="w-4 h-4 mr-1" />
            Drag and drop to change sequence order
          </p>
        </div>
        <p v-else class="text-grey py-4">
          {{ emptyStateMessage }}
        </p>
      </vx-card>

      <div class="visit-menu-save-actions">
        <template v-if="items.length && !readOnly">
          <vs-button
            v-if="!hasPersistedConfiguration"
            color="success"
            icon-pack="feather"
            icon="icon-save"
            @click="handleSave"
          >
            Save Configuration
          </vs-button>
          <vs-button
            v-else
            color="primary"
            icon-pack="feather"
            icon="icon-save"
            @click="handleUpdate"
          >
            Update Configuration
          </vs-button>
          <vs-button
            v-if="hasPersistedConfiguration"
            color="danger"
            type="border"
            icon-pack="feather"
            icon="icon-trash"
            @click="handleDelete"
          >
            Delete Configuration
          </vs-button>
        </template>
        <vs-button
          type="border"
          icon-pack="feather"
          icon="icon-arrow-left"
          @click="goToList"
        >
          Back
        </vs-button>
      </div>
    </vx-card>

    <vs-popup
      class="visit-menu-popup--conflict"
      title="Configuration Conflict"
      :active.sync="conflictPopupActive"
    >
      <p class="conflict-message">{{ conflictMessage }}</p>
      <div class="conflict-table-wrap" v-if="persistConflicts.length">
        <table class="conflict-table">
          <thead>
            <tr>
              <th>Territory</th>
              <th>Role User</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(conflict, index) in persistConflicts"
              :key="`${conflict.territory_id}-${conflict.role_id}-${conflict.work_position_id}-${index}`"
            >
              <td>{{ conflict.territory_name || "-" }}</td>
              <td>{{ conflict.role_name || "-" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import ControlSelect from "./ControlSelect.vue";

const CONFIG_URL = "/api/sfa/v1/visit-task/configuration";
const MENU_NAME_ITEMS_URL = "/api/sfa/v1/visit-task/menu-name-items";
const SUBTYPE_URL = "/api/sfa/v1/monitoring-dashboard/salesman-subtype";

function isAllFilterLabel(value) {
  return String(value || "").trim().toLowerCase() === "all";
}

function isAllFilterRecord(record) {
  if (!record || typeof record !== "object") return false;
  if (record.work_position_id === 0) return true;
  if (record.id === 0) return true;
  return ["subtype_name", "name", "display_name"].some((key) =>
    isAllFilterLabel(record[key])
  );
}

function isMissingFilterSelection(value) {
  return value == null;
}

function normalizeAllRecord(record, idKey) {
  if (!record || typeof record !== "object") return record;
  if (!isAllFilterRecord(record)) return record;
  const id = record[idKey];
  if (id === 0 || id === "0") return record;
  return { ...record, [idKey]: 0 };
}

const ALL_TERRITORY_OPTION = Object.freeze({
  id: 0,
  code: "",
  name: "ALL",
});

const ALL_ROLE_OPTION = Object.freeze({
  id: 0,
  name: "ALL",
  display_name: "ALL",
});

const ALL_SUBTYPE_OPTION = Object.freeze({
  work_position_id: 0,
  subtype_name: "ALL",
});

function buildFilterOptions(records, allOption, idKey) {
  const normalized = (Array.isArray(records) ? records : []).map((record) =>
    normalizeAllRecord(record, idKey)
  );
  const concreteOptions = normalized.filter(
    (record) => !isAllFilterRecord(record)
  );
  return [allOption, ...concreteOptions];
}

function resolveFilterId(selected, idKey) {
  if (selected == null) return undefined;
  const id = selected[idKey];
  if (id === 0 || id === "0") return 0;
  if (id != null) return id;
  if (isAllFilterRecord(selected)) return 0;
  return undefined;
}

function hasValidFilterSelections(territory, role, subtype) {
  return (
    !isMissingFilterSelection(territory) &&
    resolveFilterId(territory, "id") !== undefined &&
    !isMissingFilterSelection(role) &&
    resolveFilterId(role, "id") !== undefined &&
    !isMissingFilterSelection(subtype) &&
    resolveFilterId(subtype, "work_position_id") !== undefined
  );
}

function getMissingFilterLabels(territory, role, subtype) {
  const missing = [];
  if (
    isMissingFilterSelection(territory) ||
    resolveFilterId(territory, "id") === undefined
  ) {
    missing.push("Territory");
  }
  if (
    isMissingFilterSelection(role) ||
    resolveFilterId(role, "id") === undefined
  ) {
    missing.push("Role User");
  }
  if (
    isMissingFilterSelection(subtype) ||
    resolveFilterId(subtype, "work_position_id") === undefined
  ) {
    missing.push("Salesman Subtype");
  }
  return missing;
}

const CONTROL_NONE = "None";

function normalizeControlValue(value) {
  if (value === "Block" || value === "Warning") return value;
  return CONTROL_NONE;
}

function mapControlToApi(value) {
  if (value === "Block" || value === "Warning") return value;
  return null;
}

function coerceIsActive(value) {
  if (value === true || value === 1 || value === "1" || value === "true") {
    return true;
  }
  return false;
}

function clearInactiveRowFields(row) {
  row.sequence_number = null;
  row.sequence_control = null;
  row.out_of_radius_in_route = null;
  row.out_of_radius_off_route = null;
}

function extractPersistConflicts(resp) {
  if (!resp || resp.data == null) return [];
  const conflicts = resp.data.conflicts;
  return Array.isArray(conflicts) ? conflicts : [];
}

export default {
  name: "VisitMenuConfigurationForm",
  components: {
    draggable,
    ControlSelect,
  },
  data() {
    return {
      selectedTerritory: null,
      selectedRole: null,
      selectedSubtype: null,
      optionTerritory: [],
      optionRole: [],
      optionSubtype: [],
      searchTerritory: "",
      searchSubtype: "",
      items: [],
      hasPersistedConfiguration: false,
      menuNameItems: [],
      controlOptions: [CONTROL_NONE, "Block", "Warning"],
      conflictPopupActive: false,
      conflictMessage: "",
      persistConflicts: [],
      configName: "",
    };
  },
  computed: {
    mode() {
      const name = this.$route.name || "";
      if (name === "visit-menu-configuration-view") return "view";
      if (name === "visit-menu-configuration-edit") return "edit";
      return "create";
    },
    readOnly() {
      return this.mode === "view";
    },
    filtersLocked() {
      return this.mode !== "create";
    },
    pageTitle() {
      const labels = {
        create: "Create Visit Menu Configuration",
        edit: "Edit Visit Menu Configuration",
        view: "View Visit Menu Configuration",
      };
      const base = labels[this.mode] || "Visit Menu Configuration";
      return this.configName ? `${base} - ${this.configName}` : base;
    },
    emptyStateMessage() {
      if (!this.menuNameItems.length) {
        return "Menu list is not available. Please refresh the page.";
      }
      return "Select filters and click Apply to load configuration.";
    },
    activeItemCount() {
      return this.items.filter((row) => coerceIsActive(row.is_active)).length;
    },
  },
  methods: {
    goToList() {
      this.$router.push({ name: "visit-menu-configuration" });
    },
    applyScopeFromQuery() {
      const q = this.$route.query || {};
      this.configName = q.config_name || "";
      this.selectedTerritory = {
        id: Number(q.territory_id),
        code: "",
        name: q.territory_name || "",
      };
      this.selectedRole = {
        id: Number(q.role_id),
        name: q.role_name || "",
        display_name: q.role_name || "",
      };
      this.selectedSubtype = {
        work_position_id: Number(q.work_position_id),
        subtype_name: q.subtype_name || "",
      };
    },
    isApiSuccess(resp) {
      return (
        resp &&
        (resp.code === 200 ||
          resp.status === "success" ||
          resp.status === "OK")
      );
    },
    extractConfigurationItems(resp) {
      if (!resp || resp.data == null) return [];
      if (Array.isArray(resp.data)) return resp.data;
      if (Array.isArray(resp.data.items)) return resp.data.items;
      return [];
    },
    loadMenuNameItems() {
      this.$http
        .get(MENU_NAME_ITEMS_URL)
        .then((resp) => {
          if (this.isApiSuccess(resp) && Array.isArray(resp.data)) {
            this.menuNameItems = resp.data;
          } else {
            this.menuNameItems = [];
            this.notifyError(resp.message || "Failed to load menu items");
          }
        })
        .catch(() => {
          this.menuNameItems = [];
          this.notifyError("Failed to load menu items");
        });
    },
    customLableTerritory({ code, name }) {
      return `${code || ""} ${name || ""}`.trim();
    },
    customLabelRole(role) {
      return role.display_name || role.name || "";
    },
    getFilterParams() {
      return {
        territory_id: resolveFilterId(this.selectedTerritory, "id"),
        role_id: resolveFilterId(this.selectedRole, "id"),
        work_position_id: resolveFilterId(
          this.selectedSubtype,
          "work_position_id"
        ),
      };
    },
    handlerSearchTerritory(query) {
      this.searchTerritory = query;
      this.getTerritory();
    },
    handlerSearchSubtype(query) {
      this.searchSubtype = query;
      this.getSalesmanSubtype();
    },
    restoreFilterSelection(options, selected, idKey) {
      const selectedId = resolveFilterId(selected, idKey);
      if (selectedId === undefined) return;
      const matched = options.find(
        (option) => resolveFilterId(option, idKey) === selectedId
      );
      if (matched) {
        return matched;
      }
    },
    getTerritory() {
      const selectedTerritory = this.selectedTerritory;
      const currentUser = this.$store.state.user.currentUser;
      const company_id =
        currentUser && currentUser.company_id != null
          ? currentUser.company_id
          : 2;
      this.$vs.loading();
      this.$http
        .get("/api/sfa/v1/territory", {
          params: { company_id, search: this.searchTerritory },
        })
        .then((resp) => {
          if (resp.code == 200 && resp.data.records) {
            this.optionTerritory = buildFilterOptions(
              resp.data.records,
              ALL_TERRITORY_OPTION,
              "id"
            );
            const matched = this.restoreFilterSelection(
              this.optionTerritory,
              selectedTerritory,
              "id"
            );
            if (matched) {
              this.selectedTerritory = matched;
            }
          } else {
            this.optionTerritory = buildFilterOptions(
              [],
              ALL_TERRITORY_OPTION,
              "id"
            );
          }
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
          this.notifyError("Failed to load territory options");
        });
    },
    getRole() {
      const selectedRole = this.selectedRole;
      this.$http
        .get("/api/sfa/v1/setting/role", { params: { source: "SFA" } })
        .then((resp) => {
          if (resp.code == 200 && resp.data.records) {
            this.optionRole = buildFilterOptions(
              resp.data.records,
              ALL_ROLE_OPTION,
              "id"
            );
            const matched = this.restoreFilterSelection(
              this.optionRole,
              selectedRole,
              "id"
            );
            if (matched) {
              this.selectedRole = matched;
            }
          } else {
            this.optionRole = buildFilterOptions([], ALL_ROLE_OPTION, "id");
          }
        })
        .catch(() => this.notifyError("Failed to load role options"));
    },
    getSalesmanSubtype() {
      const selectedSubtype = this.selectedSubtype;
      this.$http
        .get(SUBTYPE_URL, { params: { search: this.searchSubtype } })
        .then((resp) => {
          if (resp.code == 200 && resp.data.records) {
            this.optionSubtype = buildFilterOptions(
              resp.data.records,
              ALL_SUBTYPE_OPTION,
              "work_position_id"
            );
            const matched = this.restoreFilterSelection(
              this.optionSubtype,
              selectedSubtype,
              "work_position_id"
            );
            if (matched) {
              this.selectedSubtype = matched;
            }
          } else {
            this.optionSubtype = buildFilterOptions(
              [],
              ALL_SUBTYPE_OPTION,
              "work_position_id"
            );
          }
        })
        .catch(() => {
          this.optionSubtype = buildFilterOptions(
            [],
            ALL_SUBTYPE_OPTION,
            "work_position_id"
          );
        });
    },
    notifyMissingFilters() {
      const missing = getMissingFilterLabels(
        this.selectedTerritory,
        this.selectedRole,
        this.selectedSubtype
      );
      this.$vs.notify({
        title: "Validation",
        text:
          missing.length === 3
            ? "Territory, Role User, and Salesman Subtype are required"
            : `${missing.join(", ")} ${missing.length > 1 ? "are" : "is"} required`,
        color: "warning",
        position: "top-right",
      });
    },
    handleApply() {
      if (
        !hasValidFilterSelections(
          this.selectedTerritory,
          this.selectedRole,
          this.selectedSubtype
        )
      ) {
        this.notifyMissingFilters();
        return;
      }
      this.loadConfiguration();
    },
    buildDefaultItemsFromMaster() {
      return this.menuNameItems.map((menu_name) => ({
        id: null,
        menu_name,
        is_active: true,
        sequence_number: null,
        sequence_control: CONTROL_NONE,
        out_of_radius_in_route: CONTROL_NONE,
        out_of_radius_off_route: CONTROL_NONE,
      }));
    },
    loadConfiguration() {
      this.$vs.loading();
      this.$http
        .get(CONFIG_URL, { params: this.getFilterParams() })
        .then((resp) => {
          if (this.isApiSuccess(resp)) {
            const normalized = this.normalizeItems(
              this.extractConfigurationItems(resp)
            );
            if (normalized.length) {
              this.items = normalized;
              this.hasPersistedConfiguration = true;
              this.recomputeSequence();
            } else if (this.menuNameItems.length) {
              this.items = this.buildDefaultItemsFromMaster();
              this.hasPersistedConfiguration = false;
              this.recomputeSequence();
            } else {
              this.items = [];
              this.hasPersistedConfiguration = false;
              this.$vs.notify({
                title: "Info",
                text: "Menu list is not available. Please refresh the page.",
                color: "warning",
                position: "top-right",
              });
            }
          } else {
            this.items = [];
            this.hasPersistedConfiguration = false;
            this.notifyError(resp.message || "Failed to load configuration");
          }
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
          this.hasPersistedConfiguration = false;
          this.notifyError("Failed to load configuration");
        });
    },
    isRowActive(row) {
      return coerceIsActive(row.is_active);
    },
    handleStatusInput(row, val) {
      if (this.readOnly) return;
      row.is_active = coerceIsActive(val);
      this.onStatusChange(row);
    },
    resolveSequenceInputValue(value) {
      if (value != null && typeof value === "object" && value.target) {
        return value.target.value;
      }
      return value;
    },
    clampSequenceNumber(value, max) {
      if (value === "" || value == null) return null;
      const num = parseInt(String(value), 10);
      if (Number.isNaN(num)) return null;
      if (max <= 0) return null;
      if (num < 1) return 1;
      if (num > max) return max;
      return num;
    },
    handleSequenceInput(row, value) {
      if (this.readOnly) return;
      const max = this.activeItemCount;
      const clamped = this.clampSequenceNumber(
        this.resolveSequenceInputValue(value),
        max
      );
      this.$set(row, "sequence_number", clamped);
    },
    mapSaveItem(row, forCreate = false) {
      const isActive = coerceIsActive(row.is_active);
      const item = {
        menu_name: row.menu_name,
        is_active: isActive,
        sequence_number: isActive ? row.sequence_number : null,
        sequence_control: isActive
          ? mapControlToApi(row.sequence_control)
          : null,
        out_of_radius_in_route: isActive
          ? mapControlToApi(row.out_of_radius_in_route)
          : null,
        out_of_radius_off_route: isActive
          ? mapControlToApi(row.out_of_radius_off_route)
          : null,
      };
      if (!forCreate && row.id) {
        item.id = row.id;
      }
      return item;
    },
    mapAllSaveItems() {
      return this.items.map((row) => this.mapSaveItem(row, false));
    },
    preparePersist() {
      this.syncRowsBeforeSave();
      this.sortItemsBySequence();
      return this.validateBeforeSave();
    },
    handlePersistSuccess(resp, mode) {
      this.$vs.loading.close();
      const successMessages = {
        saved: "Configuration saved successfully",
        updated: "Configuration updated successfully",
      };
      if (this.isApiSuccess(resp)) {
        this.$vs.notify({
          title: "Success",
          text: resp.message || successMessages[mode] || successMessages.saved,
          color: "success",
          position: "top-right",
        });
        this.goToList();
      } else {
        this.handlePersistFailure(resp, mode);
      }
    },
    showPersistConflictDialog(resp) {
      const conflicts = extractPersistConflicts(resp);
      if (!conflicts.length) return false;
      this.conflictMessage =
        resp.message ||
        "Configuration cannot be saved due to scope conflict with existing configurations";
      this.persistConflicts = conflicts;
      this.conflictPopupActive = true;
      return true;
    },
    handlePersistFailure(resp, mode) {
      if (this.showPersistConflictDialog(resp)) return;
      const errorMessages = {
        saved: "Failed to save configuration",
        updated: "Failed to update configuration",
      };
      this.notifyError(resp.message || errorMessages[mode] || errorMessages.saved);
    },
    handlePersistError(mode, resp) {
      this.$vs.loading.close();
      if (resp && this.showPersistConflictDialog(resp)) return;
      const errorMessages = {
        saved: "Failed to save configuration",
        updated: "Failed to update configuration",
      };
      this.notifyError(errorMessages[mode] || errorMessages.saved);
    },
    normalizeItems(data) {
      return (data || []).map((item) => this.normalizeRowItem(item));
    },
    normalizeRowItem(item) {
      const isActive = coerceIsActive(item.is_active);
      return {
        ...item,
        is_active: isActive,
        sequence_number: isActive ? item.sequence_number : null,
        sequence_control: isActive
          ? this.normalizeControl(item.sequence_control)
          : null,
        out_of_radius_in_route: isActive
          ? this.normalizeControl(item.out_of_radius_in_route)
          : null,
        out_of_radius_off_route: isActive
          ? this.normalizeControl(item.out_of_radius_off_route)
          : null,
      };
    },
    syncRowsBeforeSave() {
      this.items.forEach((row) => {
        row.is_active = coerceIsActive(row.is_active);
        if (!row.is_active) {
          clearInactiveRowFields(row);
        }
      });
    },
    sortItemsBySequence() {
      const active = [];
      const inactive = [];
      this.items.forEach((row) => {
        if (coerceIsActive(row.is_active)) {
          active.push(row);
        } else {
          inactive.push(row);
        }
      });
      active.sort((a, b) => {
        const seqA = Number(a.sequence_number);
        const seqB = Number(b.sequence_number);
        if (Number.isNaN(seqA) && Number.isNaN(seqB)) return 0;
        if (Number.isNaN(seqA)) return 1;
        if (Number.isNaN(seqB)) return -1;
        return seqA - seqB;
      });
      this.items = [...active, ...inactive];
    },
    normalizeControl(value) {
      return normalizeControlValue(value);
    },
    handleReset() {
      this.selectedTerritory = null;
      this.selectedRole = null;
      this.selectedSubtype = null;
      this.items = [];
      this.hasPersistedConfiguration = false;
      this.searchTerritory = "";
      this.searchSubtype = "";
      this.getTerritory();
      this.getSalesmanSubtype();
    },
    onStatusChange(row) {
      row.is_active = coerceIsActive(row.is_active);
      if (!row.is_active) {
        clearInactiveRowFields(row);
      } else {
        row.sequence_control = row.sequence_control || CONTROL_NONE;
        row.out_of_radius_in_route = row.out_of_radius_in_route || CONTROL_NONE;
        row.out_of_radius_off_route =
          row.out_of_radius_off_route || CONTROL_NONE;
      }
      this.recomputeSequence();
    },
    recomputeSequence() {
      let seq = 1;
      this.items.forEach((row) => {
        if (coerceIsActive(row.is_active)) {
          row.sequence_number = seq;
          seq += 1;
        } else {
          row.is_active = false;
          clearInactiveRowFields(row);
        }
      });
    },
    validateBeforeSave() {
      if (
        !hasValidFilterSelections(
          this.selectedTerritory,
          this.selectedRole,
          this.selectedSubtype
        )
      ) {
        this.notifyMissingFilters();
        return false;
      }
      if (!this.items.length) {
        this.$vs.notify({
          title: "Validation",
          text: "No items to save",
          color: "warning",
          position: "top-right",
        });
        return false;
      }
      const activeCount = this.activeItemCount;
      const activeRows = this.items.filter((r) => coerceIsActive(r.is_active));
      const invalidRange = activeRows.some((row) => {
        const seq = Number(row.sequence_number);
        return (
          row.sequence_number == null ||
          row.sequence_number === "" ||
          !Number.isInteger(seq) ||
          seq < 1 ||
          seq > activeCount
        );
      });
      if (invalidRange) {
        this.$vs.notify({
          title: "Validation",
          text: `Sequence must be between 1 and ${activeCount} and unique for active items`,
          color: "warning",
          position: "top-right",
        });
        return false;
      }
      const sequences = activeRows.map((r) => Number(r.sequence_number));
      if (new Set(sequences).size !== sequences.length) {
        this.$vs.notify({
          title: "Validation",
          text: `Sequence must be between 1 and ${activeCount} and unique for active items`,
          color: "warning",
          position: "top-right",
        });
        return false;
      }
      return true;
    },
    handleSave() {
      if (!this.preparePersist()) return;

      const params = this.getFilterParams();

      this.$vs.loading();
      this.$http
        .post(CONFIG_URL, {
          ...params,
          items: this.items.map((row) => this.mapSaveItem(row, true)),
        })
        .then((resp) => this.handlePersistSuccess(resp, "saved"))
        .catch((resp) => this.handlePersistError("saved", resp));
    },
    handleUpdate() {
      if (!this.preparePersist()) return;

      const params = this.getFilterParams();

      this.$vs.loading();
      this.$http
        .put(CONFIG_URL, {
          ...params,
          items: this.mapAllSaveItems(),
        })
        .then((resp) => this.handlePersistSuccess(resp, "updated"))
        .catch((resp) => this.handlePersistError("updated", resp));
    },
    handleDelete() {
      if (
        !hasValidFilterSelections(
          this.selectedTerritory,
          this.selectedRole,
          this.selectedSubtype
        )
      ) {
        this.notifyMissingFilters();
        return;
      }
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: "Please confirm to delete configuration for the selected filter",
        accept: this.acceptDelete,
      });
    },
    acceptDelete() {
      this.$vs.loading();
      this.$http
        .delete(CONFIG_URL, { params: this.getFilterParams() })
        .then((resp) => {
          this.$vs.loading.close();
          if (this.isApiSuccess(resp)) {
            const deletedCount = resp.data
              ? resp.data.deleted_count
              : resp.deleted_count;
            const successText =
              deletedCount != null
                ? `${deletedCount} configuration(s) deleted successfully`
                : resp.message || "Configuration deleted successfully";
            this.$vs.notify({
              title: "Success",
              text: successText,
              color: "success",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
            this.goToList();
          } else {
            this.notifyError(resp.message || "Failed to delete configuration");
          }
        })
        .catch(() => {
          this.$vs.loading.close();
          this.notifyError("Failed to delete configuration");
        });
    },
    notifyError(text) {
      this.$vs.notify({
        title: "Error",
        text,
        color: "danger",
        position: "top-right",
      });
    },
  },
  mounted() {
    this.getTerritory();
    this.getRole();
    this.getSalesmanSubtype();
    this.loadMenuNameItems();
    if (this.mode === "edit" || this.mode === "view") {
      this.applyScopeFromQuery();
      this.loadConfiguration();
    }
  },
};
</script>

<style scoped>
.filter-inline {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px;
}

.filter-field {
  flex: 1 1 200px;
  min-width: 180px;
}

.filter-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 0 0 auto;
  padding-bottom: 2px;
}

.config-item-table {
  width: 100%;
  overflow-x: auto;
}

.visit-menu-table {
  table-layout: fixed;
  width: 100%;
}

.visit-menu-table thead th {
  font-weight: 600;
  font-size: 12px;
  padding: 10px 8px;
  vertical-align: middle;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.th-group-center {
  text-align: center;
}

.th-num {
  width: 48px;
}

.th-order {
  width: 56px;
  text-align: center;
}

.visit-menu-table .td {
  vertical-align: middle;
  padding: 8px;
}

.cell-content--status {
  max-width: 140px;
}

.cell-content--sequence {
  max-width: 72px;
}

.cell-content--control {
  max-width: 140px;
}

.sequence-input {
  max-width: 72px;
}

.col-order {
  text-align: center;
}

.drag-handle {
  cursor: move;
  font-size: 18px;
  color: rgba(var(--vs-text), 0.6);
}

.control-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 13px;
  font-weight: 500;
}

.control-badge--block {
  background-color: rgba(234, 84, 85, 0.15);
  color: #ea5455;
}

.control-badge--warning {
  background-color: rgba(255, 159, 67, 0.15);
  color: #ff9f43;
}

.visit-menu-save-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 1.5rem;
}

.conflict-message {
  margin: 0 0 1rem;
  font-size: 14px;
  line-height: 1.5;
  color: rgba(var(--vs-text), 0.85);
}

.conflict-table-wrap {
  overflow-x: auto;
}

.conflict-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.conflict-table th,
.conflict-table td {
  padding: 8px 10px;
  text-align: left;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.conflict-table th {
  font-weight: 600;
}
</style>

<style>
.visit-menu-popup--conflict .vs-popup {
  width: 560px !important;
  max-width: calc(100vw - 2rem);
}
.visit-menu-popup--conflict .vs-popup--content {
  padding: 1rem 1.25rem 1.25rem !important;
  min-height: unset !important;
}
.visit-menu-popup--form .vs-popup {
  width: 520px !important;
  max-width: calc(100vw - 2rem);
}
.visit-menu-popup--form .vs-popup--content {
  padding: 1rem 1.25rem 1.25rem !important;
  min-height: unset !important;
  overflow: visible !important;
}
.visit-menu-popup--form .multiselect__content-wrapper {
  z-index: 53001 !important;
}
</style>
